import DEVICE_ENDPOINT_MAP from '../constants/device-ws-endpoint-map.json';
import WEBRTC_DNS_MAP from '../constants/webrtc-dns-map.json';

type DEVICE_MAP_KEY = keyof typeof DEVICE_ENDPOINT_MAP;
type DNS_MAP_KEY = keyof typeof WEBRTC_DNS_MAP;

export function convertDeviceInfoToWsEndpoint(address: string, port: number) {
  const isIp = !/[a-zA-Z]+/.test(address);
  const key = (isIp ? address : address.split('.')[0]) as DEVICE_MAP_KEY
  return `${DEVICE_ENDPOINT_MAP[key]}/${port}`;
}

export function washWebrtcAnswerSdp(sdp: string, ip: string, port: number) {
  /*
    Q: Why do this?
    A: This is a chrome bug, chrome version >= 123 ZLMRTCClient BUG;

    https://issues.webrtc.org/issues/42226210
    https://github.com/ZLMediaKit/ZLMediaKit/commit/1e3959433522808f3390bc9748ae96af793906dc
    https://webrtc.googlesource.com/src/+/refs/heads/lkgr/pc/webrtc_sdp.cc -> line: 2872
  */
  let _sdp = sdp.split('\r\n').filter((line: string) => !line.includes('msid:zlmediakit-mslabel zlmediakit-label')).join('\r\n');

  // replace ip and port
  const pattern = /(candidate:[^\s]+ \d+ (udp|tcp) \d+ )([0-9.]+) (\d+)(.*)/g;
  const _ip = WEBRTC_DNS_MAP[ip as DNS_MAP_KEY] || ip;
  return _sdp.replace(pattern, `$1${_ip} ${port}$5`);
}
